






















import { listFactory } from '@/main/pages';
import { convertToObjects, EditableStatus, Row } from '@/main/utils/table';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import _ from 'lodash';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';

import { COL_OSOBNI_CIS, COL_PRACOVNIK_ID, NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	components: {
		DmsEditableTable,
	},
	data() {
		return {
			osobniCis: COL_OSOBNI_CIS,
			pracovnikId: COL_PRACOVNIK_ID,
		};
	},
	computed: {
		isTableModified() {
			return this.table.isModified();
		},
	},
	methods: {
		getOsobniCisText(row: Row, columnId: number) {
			return this.dropdownList.OsobniCis.find((item: any) => item.Text === row.cells[columnId])?.Text;
		},
		async updatePracovnik(row: Row, value: any, columnId: number, updateColumn: (value: any, columnId: number) => void) {
			if (_.isNil(this.table.cellNames)) return;
			this.startLoading();
			const pracovnikIdCol = this.table.cellNames.PRACOVNIK_ID;
			updateColumn(value, pracovnikIdCol);

			const { Jmeno, Prijmeni } = (await Pracovnik.apiProvider.entity(value)).data;
			const prijmeniCol = this.table.cellNames.PRIJMENI;
			updateColumn(Prijmeni, prijmeniCol);

			const jmenoCol = this.table.cellNames.JMENO;
			updateColumn(Jmeno, jmenoCol);

			const osobniCisText = this.dropdownList.OsobniCis.find((item: any) => item.Value === value)?.Text;
			updateColumn(osobniCisText, columnId);
			this.endLoading();
		},
		rowSaved({ row: newRow }: { row: Row }) {
			const casJdnPocColId = this.table.cellNames!.CAS_JDN_POC;
			const rowId = this.table.cellNames!.idColumn;
			const reducer = (sum: number, row: Row) => (
				(row.cells[rowId] === newRow.cells[rowId])
					? sum
					: sum + row.cells[casJdnPocColId]
			);
			const currentSummary = this.table.rows.reduce(reducer, 0) + newRow.cells[casJdnPocColId];
			const remainingSummary = (this.props.SumaCj ?? 0) - currentSummary;
			this.table.defaultRowModel!.cells[casJdnPocColId] = (remainingSummary < 0) ? 0 : remainingSummary;
		},
		updateRow(rowUpdateData: { tableName: string; updateStatus: EditableStatus; rowId: number; row: Row }) {
			this.updateTableRow(rowUpdateData);
		},
		async update() {
			const { columns, rows } = this.table;
			const isSaved = await this.updateDelbaPpRows(convertToObjects({ columns, rows }));
			if (isSaved && isSaved.data) {
				this.$router.back();
			}
		},
	},
});
